module.exports = __webpack_public_path__ + "img/yll_intro.64a71aef.png";